/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityContextLink
 */
export interface ActivityContextLink {
    /**
     * 
     * @type {string}
     * @memberof ActivityContextLink
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityContextLink
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityContextLink
     */
    name: string;
}

/**
 * Check if a given object implements the ActivityContextLink interface.
 */
export function instanceOfActivityContextLink(value: object): value is ActivityContextLink {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ActivityContextLinkFromJSON(json: any): ActivityContextLink {
    return ActivityContextLinkFromJSONTyped(json, false);
}

export function ActivityContextLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityContextLink {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function ActivityContextLinkToJSON(json: any): ActivityContextLink {
    return ActivityContextLinkToJSONTyped(json, false);
}

export function ActivityContextLinkToJSONTyped(value?: ActivityContextLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'id': value['id'],
        'name': value['name'],
    };
}

